import React, { ReactElement } from 'react';
import ToolTip from '@/components/@IntranetLibrary/ToolTip';

interface ToolbarTooltipProps {
  title: string;
  children: ReactElement;
}

/**
 * 플로팅 툴바 버튼용 툴팁.
 * - ToolTip이 arrow를 좌측(arrowOffset)으로 고정하므로 중앙 정렬로 되돌린다.
 * - disabled 버튼은 마우스 이벤트를 발생시키지 않아 span으로 한 번 감싼다.
 */
const ToolbarTooltip: React.FC<ToolbarTooltipProps> = ({ title, children }) => (
  <ToolTip
    title={title}
    placement="top"
    slotProps={{
      arrow: {
        sx: {
          left: '50% !important',
          right: 'auto !important',
          transform: 'translateX(-50%) !important',
        },
      },
    }}
  >
    <span style={{ display: 'inline-flex' }}>{children}</span>
  </ToolTip>
);

export default ToolbarTooltip;
